let counter = 0;

const nextKey = (name) => {
    return `${name}_${++counter}`;
}

export default nextKey;